<template>
  <v-app id="inspire">
    <v-system-bar app>
      <v-spacer></v-spacer>

      <v-icon>mdi-square</v-icon>

      <v-icon>mdi-circle</v-icon>

      <v-icon>mdi-triangle</v-icon>
    </v-system-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <v-sheet
        color="grey lighten-4"
        class="pa-4"
      >
        <v-avatar
          class="mb-4"
          color="grey darken-1"
          size="64"
        ></v-avatar>

        <div>john@vuetifyjs.com</div>
      </v-sheet>

      <v-divider></v-divider>

      <v-list>
        <v-list-item
          v-for="[icon, text] in links"
          :key="icon"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-container
        class="py-8 px-6"
        fluid
      >
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card"
            cols="12"
          >

      <v-card  color="#385F73"  dark >
          <div class="d-flex flex-no-wrap">
            <div>
         

              <v-card-text class="ma-2 pa-0">
                <p class="ma-0 pa-0">Select 30 second exercises to do at you desk or in you home</p>       
                <p class="ma-0 pa-0">Click the play button to start your session</p>
                <p class="ma-0 pa-0">Aim for 5 minute sessions. 3-5 time a day.</p>
                <p class="ma-0 pa-0">Encourages stretching and movement throughout the day</p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
              <v-btn @click="navigateToSession()">
        <span>Start Session</span>

        <v-icon>play_circle</v-icon>
      </v-btn> 
      <v-spacer></v-spacer>
              </v-card-actions>
            </div>
          </div>
        </v-card>



          
            <v-card>
              <v-subheader>{{ card }}</v-subheader>

              <v-list two-line>
                <template v-for="(item) in exercises">
                  <v-list-item

                    :key="item"
                  >
                    <v-list-item-avatar color="grey darken-1">
                    <v-img :src="item.image" :max-width="40"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>

                      <v-list-item-subtitle>
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nihil repellendus distinctio similique
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider
                    v-if="n !== 6"
                    :key="`divider-${item}`"
                    inset
                  ></v-divider>
                </template>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>



<script>
export default {

  name: 'ExerciseList',

  data: () => ({

 cards: ['Exercises'],
      drawer: null,

      links: [
        ['mdi-inbox-arrow-down', 'Inbox'],
        ['mdi-send', 'Send'],
        ['mdi-delete', 'Trash'],
        ['mdi-alert-octagon', 'Spam'],
      ],

    snackbar: false,
    exercises: [],
    selected: [],
    currentSet: 
    { "saved": false, // i.e. currently unsaved Set
      "exercises" : []},
    listCreated: false,
  
  }),
  mounted() {

    },
  created() {
    this.getExercises();
    console.log(this.exercises);
    console.log(this.setList);
    // reset currentSet to 0
    
  },
  methods: {
    menuActionClick(index) {
        
        if(this.listCreated) {
            // Add to the existing Set list
            console.log("Add to Set...");
            this.$store.dispatch('addExerciseToSet', this.exercises[index])
            this.listCreated=true;
          } else {
            // create a new Set list
            console.log("Create new Set...");
            this.currentSet.saved=false;
            this.currentSet.exercises.push(this.exercises[index]);
            this.$store.dispatch('currentSet', this.currentSet);
          }
      // DEBUG ONLY

      console.log("getCurrentSet:");
      console.log(this.$store.getters.getCurrentSet);      

        
      },
    getExercises: function () {
      this.exercises = this.$store.getters.sortedExercises;
      console.log("getExercises:BEFORE");
      console.log(this.exercises);
      console.log("getExercises:AFTER");
    },
     navigateToSession() {
      let setData=this.$store.getters.getCurrentSet;

      if(setData=="") {
        this.snackbar=true;
      }
      else if(setData=="" || setData.exercises.length>0) {
              this.$router.push('session');
      } else {
        this.snackbar=true;
      }

    }

  }          
}
</script>
